module.exports = __webpack_public_path__ + "img/icon01_highlight.4371905.png";